import {
  AutomaticRefreshFrequencyMenuItem,
  ProxyReplacementsMenuItem,
} from "./CustomizeMenuTypes";

export const rotatingISPAutomaticRefreshFrequencyMenuItems: AutomaticRefreshFrequencyMenuItem[] =
  [
    {
      period: 1200,
      name: "Up to 5,000 IPs/month",
      description: "Regular",
      isPopular: true,
      isDefault: true,
    },
    {
      period: 300,
      name: "Up to 20,000 IPs/month",
      description: "Large",
    },
  ];

export const rotatingAutomaticRefreshFrequencyMenuItems: AutomaticRefreshFrequencyMenuItem[] =
  [
    {
      period: 300,
      name: "Up to 50,000 IPs/month",
      description: "Regular",
      isPopular: true,
      isDefault: true,
    },
    {
      period: 60,
      name: "Up to 200,000 IPs/month",
      description: "Large",
    },
  ];

export const proxyReplacementsMenuItems: ProxyReplacementsMenuItem[] = [
  {
    proxyReplacementsCount: 10,
    name: "10 Replacements",
    isDefault: true,
    description: "Replace individual proxies",
  },
  {
    proxyReplacementsCount: 50,
    name: "50 Replacements",
    description: "Replace individual proxies",
    isPopular: true,
  },
  {
    proxyReplacementsCount: 100,
    name: "100 Replacements",
    description: "Replace individual proxies",
  },
  {
    proxyReplacementsCount: 250,
    name: "250 Replacements",
    description: "Replace individual proxies",
  },
  {
    proxyReplacementsCount: 500,
    name: "500 Replacements",
    description: "Replace individual proxies",
  },
  {
    proxyReplacementsCount: 1000,
    name: "1,000 Replacements",
    description: "Replace individual proxies",
  },
  {
    proxyReplacementsCount: 2500,
    name: "2,500 Replacements",
    description: "Replace individual proxies",
  },
  {
    proxyReplacementsCount: 5000,
    name: "5,000 Replacements",
    description: "Replace individual proxies",
  },
];
